<template>
  <div class="searchbar">
    <div class="container no-padding">
      <div class="title">
        <i class="title__icon icon-kp-graph mobile-hide" aria-hidden="true"></i>
        <div class="breadcrumb mobile-hide">
          <router-link class="breadcrumb__item" :to="{ name: 'Show', params: { locale: i18n.locale, pageIdentifier: $route.params.pageIdentifier }}">
            {{ $t('analytics.header.title') }}
          </router-link>
          <span class="breadcrumb__item" v-if="breadcrumb">{{ breadcrumb }}</span>
        </div>
        <a :href="klickartUrl" class="mt-desktop--largee button-back">
          <i class="button__icon fa fa-arrow-left"></i>
          {{ $t('analytics.header.back') }}
        </a>
      </div>
      <klickart-header-subtitle v-if="isKlickartPage"></klickart-header-subtitle>
      <new-editor-header-subtitle v-else></new-editor-header-subtitle>
    </div>
  </div>
</template>

<script>
import KlickartHeaderSubtitle from './subtitle/KlickartHeaderSubtitle';
import NewEditorHeaderSubtitle from './subtitle/NewEditorHeaderSubtitle';

import i18n from '../../../i18n';
import rebrand from '../../../config/rebrand';

export default {
  components: {
    KlickartHeaderSubtitle,
    NewEditorHeaderSubtitle,
  },
  data() {
    return {
      klickartUrl: rebrand.urls.KLICKART_URL.replace('http:', 'https:'),
      menuOpen: false,
      isKlickartPage: !!Number(this.$route.params.pageIdentifier),
      i18n,
    };
  },
  props: [
    'breadcrumb',
  ],
};
</script>



// WEBPACK FOOTER //
// src/screens/Layout/components/KlickartAnalyticsHeader.vue